// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND = "Aktu\u00e1ln\u011b nem\u00e1\u0161 v bazaru \u017e\u00e1dn\u00fd inzer\u00e1t na ko\u010d\u00e1rek nebo nem\u00e1\u0161 spr\u00e1vn\u011b vypln\u011bn\u00fd model ko\u010d\u00e1rku.";
